import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import Header from './components/Header/Header.jsx';
import List from './components/List/List.jsx';
import Map from './components/Map/Map.jsx';

const MapApp = () => {
    const [distributor, setDistributor] = useState([]);
    const [filteredDistributor, setFilteredDistributor] = useState([]);
    const [coordinates, setCoordinates] = useState({ lat: 34.06533469999998, lng: -118.243891 });
    const [type, setType] = useState('breathing-air');
    const [childClicked, setChildClicked] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const queryString = `
    {
        distributorLocationGraphql {
          results {
            title
            field_short_name
            field_distributor_location
            field_email
            field_phone
            field_website
            field_main_point_of_contact
            field_map_latitude
            field_map_longitude
            field_distributor_coverage_id
          }
        }
      }
    `;

    function calcDistance(p1, p2) {
        return (google.maps.geometry.spherical.computeDistanceBetween(p1, p2) / 1000).toFixed(2);
    }

    function filteroutdist() {
        const distributorraw = distributor.map(x => {
            const distributorlat = x.field_map_latitude
            const distributorlng = x.field_map_longitude
            const userlat = coordinates.lat;
            const userlng = coordinates.lng;

            var p1 = new google.maps.LatLng(userlat, userlng);
            var p2 = new google.maps.LatLng(distributorlat, distributorlng);

            const distance = (calcDistance(p1, p2));
            return { id: distributorlat, distance: distance };
        })

        const sortdistributor = distributorraw.sort(function (a, b) {
            return a.distance - b.distance;
        });

        const filterdistributor = sortdistributor.slice(0, 4);

        const filterid = filterdistributor.map(x => {
            const getid = x.id;
            return getid;
        });

        const result = distributor.filter(({ field_map_latitude }) => filterid.includes(field_map_latitude));

        setFilteredDistributor(result);
    }

    useEffect(async () => {
        setIsLoading(true);
        await fetch("https://www.bauercomp.com/graphql?query=", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ query: queryString })
        })
            .then((res) => res.json())
            .then((res) => {
                const distributorList = res.data.distributorLocationGraphql.results.map((distributor) => ({
                    ...distributor
                }));
                setDistributor(Object.values(distributorList));

            });
        setIsLoading(false);
    }, []);

    useEffect(() => {
        filteroutdist();
    }, [coordinates]);

    return (
        <>
            {isLoading ? (
                <div className="distributor-finder-loading">
                    <CircularProgress size="5rem" />
                </div>
            ) : (
                <>
                    <div className="bauer-distributor-finder-search">
                        <Header
                            setCoordinates={setCoordinates}
                            type={type}
                            setType={setType}
                        />
                    </div>
                    <div className="bauer-distributor-finder-map-container">
                        <div className="bauer-distributor-map-box">
                            <Map
                                setCoordinates={setCoordinates}
                                coordinates={coordinates}
                                distributor={filteredDistributor}
                                setChildClicked={setChildClicked}
                            />
                        </div>
                        <div className="bauer-distributor-list-box">
                            <List
                                isLoading={isLoading}
                                distributor={filteredDistributor}
                                childClicked={childClicked}
                                setCoordinates={setCoordinates}
                                coordinates={coordinates}
                            />
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

export default MapApp;
